import { Box, Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '12px',
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    background: theme.palette.background.card,
    color: theme.palette.common.white,
    padding: theme.spacing(4, 4),
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(0, 3),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 6),
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  disableCard: {
    position: 'absolute',
    backdropFilter: 'blur(4px)',
    borderRadius: '12px',
  },
  textDisable: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2, 2),
  },
  textDisableCent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '240px',
  },
}));

function SkeletonDisabledCard() {
  const classes = useStyles();
  return (
    <Grid className={classes.container}>
      <Grid className={classes.disableCard}>
        <Grid container direction="row" xs={12}>
          <Grid>
            <Box align="center" className={classes.textDisableCent}>
              <Skeleton variant="rect" width={120} height={40} />
            </Box>
            <Box align="center" className={classes.textDisable}>
              <Skeleton variant="rect" width={150} height={40} />
            </Box>
          </Grid>
        </Grid>
        <Grid />
      </Grid>
      <Card className={classes.card}>
        <Box>
          <Grid>
            <Grid>
              <Box align="center" className={classes.textDisable} />
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Grid>
  );
}

export default SkeletonDisabledCard;
